"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _require = require('../../../commons/httpClient'),
  httpClient = _require.httpClient;
var store = require('../../../../../../../config/store');
var helpers = require('../../../checkout/helpers');
var _require2 = require('../../../../../../../config/constants'),
  APPLE_PAY = _require2.APPLE_PAY;
var _require3 = require('../../initializeCheckout'),
  initializeCheckout = _require3.initializeCheckout;
var _require4 = require('../../../commons'),
  createTemporaryBasket = _require4.createTemporaryBasket;
var ApplePay = /*#__PURE__*/function () {
  function ApplePay(config, applicationInfo, adyenTranslations, isExpressPdp, initialAmount) {
    var _this = this;
    _classCallCheck(this, ApplePay);
    _defineProperty(this, "formatAddress", function (data) {
      return {
        address1: _this[data].addressLines[0],
        address2: _this[data].addressLines.length > 1 ? _this[data].addressLines[1] : null,
        city: _this[data].locality,
        countryCode: {
          displayValue: _this[data].country,
          value: _this[data].countryCode
        },
        firstName: _this[data].givenName,
        lastName: _this[data].familyName,
        postalCode: _this[data].postalCode,
        stateCode: _this[data].administrativeArea
      };
    });
    _defineProperty(this, "formatCustomerObject", function () {
      var customerData = _this.customerData;
      return {
        addressBook: {
          addresses: {},
          preferredAddress: _objectSpread(_objectSpread({}, _this.formatAddress('customerData')), {}, {
            ID: customerData.emailAddress
          })
        },
        billingAddressDetails: _this.formatAddress('billingData'),
        customer: {},
        profile: {
          firstName: customerData.givenName,
          lastName: customerData.familyName,
          email: customerData.emailAddress,
          phone: customerData.phoneNumber
        }
      };
    });
    _defineProperty(this, "handleAuthorised", function (response, resolve) {
      resolve({
        resultCode: response === null || response === void 0 ? void 0 : response.resultCode,
        status: _this.APPLE_PAY_SUCCESS
      });
      if (document.querySelector('#result')) {
        var _response$fullRespons, _response$fullRespons2, _response$fullRespons3, _response$fullRespons4, _response$fullRespons5, _response$fullRespons6, _response$fullRespons7;
        document.querySelector('#result').value = JSON.stringify({
          pspReference: (_response$fullRespons = response.fullResponse) === null || _response$fullRespons === void 0 ? void 0 : _response$fullRespons.pspReference,
          resultCode: (_response$fullRespons2 = response.fullResponse) === null || _response$fullRespons2 === void 0 ? void 0 : _response$fullRespons2.resultCode,
          paymentMethod: (_response$fullRespons3 = response.fullResponse) !== null && _response$fullRespons3 !== void 0 && _response$fullRespons3.paymentMethod ? response.fullResponse.paymentMethod : (_response$fullRespons4 = response.fullResponse) === null || _response$fullRespons4 === void 0 ? void 0 : (_response$fullRespons5 = _response$fullRespons4.additionalData) === null || _response$fullRespons5 === void 0 ? void 0 : _response$fullRespons5.paymentMethod,
          donationToken: (_response$fullRespons6 = response.fullResponse) === null || _response$fullRespons6 === void 0 ? void 0 : _response$fullRespons6.donationToken,
          amount: (_response$fullRespons7 = response.fullResponse) === null || _response$fullRespons7 === void 0 ? void 0 : _response$fullRespons7.amount
        });
      }
      if (document.querySelector('#showConfirmationForm')) {
        document.querySelector('#showConfirmationForm').submit();
      }
    });
    _defineProperty(this, "handleError", function (rejectApplePay) {
      rejectApplePay({
        status: _this.APPLE_PAY_ERROR
      });
      if (document.querySelector('#result')) {
        document.querySelector('#result').value = JSON.stringify({
          error: true
        });
      }
      if (document.querySelector('#showConfirmationForm')) {
        document.querySelector('#showConfirmationForm').submit();
      }
    });
    _defineProperty(this, "handleApplePayResponse", function (response, resolveApplePay, rejectApplePay) {
      if ((response === null || response === void 0 ? void 0 : response.resultCode) === 'Authorised') {
        _this.handleAuthorised(response, resolveApplePay);
      } else {
        _this.handleError(rejectApplePay);
      }
    });
    _defineProperty(this, "callPaymentFromComponent", function (data) {
      return httpClient({
        url: _this.paymentFromComponentURL,
        method: 'POST',
        data: {
          data: JSON.stringify(data),
          paymentMethod: APPLE_PAY
        }
      });
    });
    _defineProperty(this, "selectShippingMethod", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
        var shipmentUUID, ID, requestBody;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              shipmentUUID = _ref.shipmentUUID, ID = _ref.ID;
              requestBody = {
                paymentMethodType: APPLE_PAY,
                shipmentUUID: shipmentUUID,
                methodID: ID,
                isExpressPdp: _this.isExpressPdp
              };
              return _context.abrupt("return", httpClient({
                method: 'POST',
                url: _this.selectShippingMethodUrl,
                data: {
                  data: JSON.stringify(requestBody)
                }
              }));
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    _defineProperty(this, "getShippingMethod", function (shippingContact) {
      var requestBody = {
        paymentMethodType: APPLE_PAY,
        isExpressPdp: _this.isExpressPdp
      };
      if (shippingContact) {
        requestBody.address = {
          city: shippingContact.locality,
          country: shippingContact.country,
          countryCode: shippingContact.countryCode,
          stateCode: shippingContact.administrativeArea,
          postalCode: shippingContact.postalCode
        };
      }
      return httpClient({
        method: 'POST',
        url: _this.shippingMethodsUrl,
        data: {
          data: JSON.stringify(requestBody)
        }
      });
    });
    _defineProperty(this, "onAuthorized", function (data, actions) {
      var authorizedEvent = data.authorizedEvent;
      try {
        _this.customerData = authorizedEvent.payment.shippingContact;
        _this.billingData = authorizedEvent.payment.billingContact;
        _this.customer = _this.formatCustomerObject();
        actions.resolve();
      } catch (error) {
        actions.reject();
      }
    });
    _defineProperty(this, "onSubmit", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(state, component, actions) {
        var resolve, reject, stateData, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              resolve = actions.resolve, reject = actions.reject;
              stateData = _objectSpread(_objectSpread({}, state.data), {}, {
                paymentType: 'express'
              });
              _context2.next = 4;
              return _this.callPaymentFromComponent(_objectSpread(_objectSpread({}, stateData), {}, {
                customer: _this.customer,
                isExpressPdp: _this.isExpressPdp
              }));
            case 4:
              response = _context2.sent;
              helpers.createShowConfirmationForm(_this.showConfirmationAction);
              helpers.setOrderFormData(response);
              if (document.querySelector('#additionalDetailsHidden')) {
                document.querySelector('#additionalDetailsHidden').value = JSON.stringify(stateData);
              }
              _this.handleApplePayResponse(response, resolve, reject);
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x2, _x3, _x4) {
        return _ref3.apply(this, arguments);
      };
    }());
    _defineProperty(this, "onShippingMethodSelected", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(resolve, reject, event) {
        var shippingMethod, shippingMethodsData, shippingMethods, matchingShippingMethod, calculationResponse, applePayShippingMethodUpdate;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              shippingMethod = event.shippingMethod;
              _context3.next = 3;
              return _this.getShippingMethod();
            case 3:
              shippingMethodsData = _context3.sent;
              shippingMethods = shippingMethodsData === null || shippingMethodsData === void 0 ? void 0 : shippingMethodsData.shippingMethods;
              matchingShippingMethod = shippingMethods.find(function (sm) {
                return sm.ID === shippingMethod.identifier;
              });
              _context3.next = 8;
              return _this.selectShippingMethod(matchingShippingMethod);
            case 8:
              calculationResponse = _context3.sent;
              if (calculationResponse !== null && calculationResponse !== void 0 && calculationResponse.grandTotalAmount) {
                applePayShippingMethodUpdate = {
                  newTotal: {
                    type: 'final',
                    label: _this.config.merchantName,
                    amount: calculationResponse.grandTotalAmount.value
                  }
                };
                resolve(applePayShippingMethodUpdate);
              } else {
                reject();
              }
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function (_x5, _x6, _x7) {
        return _ref4.apply(this, arguments);
      };
    }());
    _defineProperty(this, "onShippingContactSelected", /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(resolve, reject, event) {
        var _shippingMethodsData$;
        var shippingContact, shippingMethodsData, selectedShippingMethod, newCalculation, shippingMethodsStructured, applePayShippingContactUpdate;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              shippingContact = event.shippingContact;
              _context4.next = 3;
              return _this.getShippingMethod(shippingContact);
            case 3:
              shippingMethodsData = _context4.sent;
              if (!(shippingMethodsData !== null && shippingMethodsData !== void 0 && (_shippingMethodsData$ = shippingMethodsData.shippingMethods) !== null && _shippingMethodsData$ !== void 0 && _shippingMethodsData$.length)) {
                _context4.next = 12;
                break;
              }
              selectedShippingMethod = shippingMethodsData.shippingMethods[0];
              _context4.next = 8;
              return _this.selectShippingMethod(selectedShippingMethod);
            case 8:
              newCalculation = _context4.sent;
              if (newCalculation !== null && newCalculation !== void 0 && newCalculation.grandTotalAmount) {
                shippingMethodsStructured = shippingMethodsData.shippingMethods.map(function (sm) {
                  return {
                    label: sm.displayName,
                    detail: sm.description,
                    identifier: sm.ID,
                    amount: "".concat(sm.shippingCost.value)
                  };
                });
                applePayShippingContactUpdate = {
                  newShippingMethods: shippingMethodsStructured,
                  newTotal: {
                    type: 'final',
                    label: _this.config.merchantName,
                    amount: newCalculation.grandTotalAmount.value
                  }
                };
                resolve(applePayShippingContactUpdate);
              } else {
                reject();
              }
              _context4.next = 13;
              break;
            case 12:
              reject();
            case 13:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return function (_x8, _x9, _x0) {
        return _ref5.apply(this, arguments);
      };
    }());
    _defineProperty(this, "onClick", /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(resolve, reject) {
        var tempBasketResponse, applePayAmountUpdate;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!_this.isExpressPdp) {
                _context5.next = 7;
                break;
              }
              _context5.next = 3;
              return createTemporaryBasket();
            case 3:
              tempBasketResponse = _context5.sent;
              if (tempBasketResponse !== null && tempBasketResponse !== void 0 && tempBasketResponse.temporaryBasketCreated) {
                applePayAmountUpdate = {
                  newTotal: {
                    type: 'final',
                    label: _this.config.merchantName,
                    amount: tempBasketResponse.amount.value
                  }
                };
                resolve(applePayAmountUpdate);
              } else {
                reject();
              }
              _context5.next = 8;
              break;
            case 7:
              resolve();
            case 8:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      return function (_x1, _x10) {
        return _ref6.apply(this, arguments);
      };
    }());
    var _window = window,
      basketAmount = _window.basketAmount,
      showConfirmationAction = _window.showConfirmationAction,
      shippingMethodsUrl = _window.shippingMethodsUrl,
      selectShippingMethodUrl = _window.selectShippingMethodUrl,
      paymentFromComponentURL = _window.paymentFromComponentURL;
    this.store = store;
    this.helpers = helpers;
    this.amount = initialAmount || JSON.parse(basketAmount);
    this.showPayButton = true;
    this.isExpress = true;
    this.isExpressPdp = isExpressPdp;
    this.paymentFromComponentURL = paymentFromComponentURL;
    this.showConfirmationAction = showConfirmationAction;
    this.shippingMethodsUrl = shippingMethodsUrl;
    this.selectShippingMethodUrl = selectShippingMethodUrl;
    this.applicationInfo = applicationInfo;
    this.config = config;
    this.customerData = null;
    this.billingData = null;
    this.translations = adyenTranslations;
    this.APPLE_PAY_SUCCESS = 1;
    this.APPLE_PAY_ERROR = 0;
  }
  return _createClass(ApplePay, [{
    key: "getConfig",
    value: function getConfig() {
      return {
        configuration: this.config,
        showPayButton: this.showPayButton,
        amount: this.amount,
        isExpress: this.isExpress,
        requiredShippingContactFields: ['postalAddress', 'email', 'phone'],
        requiredBillingContactFields: ['postalAddress', 'phone'],
        onSubmit: this.onSubmit,
        onClick: this.onClick,
        onAuthorized: this.onAuthorized,
        onShippingMethodSelected: this.onShippingMethodSelected,
        onShippingContactSelected: this.onShippingContactSelected
      };
    }
  }, {
    key: "getComponent",
    value: function () {
      var _getComponent = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var checkout, applePayConfig;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return initializeCheckout(this.applicationInfo, this.translations);
            case 2:
              checkout = _context6.sent;
              applePayConfig = this.getConfig();
              return _context6.abrupt("return", window.AdyenWeb.createComponent(APPLE_PAY, checkout, applePayConfig));
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function getComponent() {
        return _getComponent.apply(this, arguments);
      }
      return getComponent;
    }()
  }]);
}();
module.exports = ApplePay;